import { render, staticRenderFns } from "./MemInfo.vue?vue&type=template&id=22a52a31&scoped=true"
import script from "./MemInfo.vue?vue&type=script&lang=js"
export * from "./MemInfo.vue?vue&type=script&lang=js"
import style0 from "./MemInfo.vue?vue&type=style&index=0&id=22a52a31&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22a52a31",
  null
  
)

export default component.exports